<template>
  <button v-if="options" @click="scrollToElement('feature-block-' + options.element_id)"
    class="button-box cta"><span>{{ options.button_text }}</span></button>
</template>

<script>
import SectionMixin from '@/mixins/sectionMixin'

export default {
  name: 'anchor-button',
  mixins: [SectionMixin],
  props: {
    options:{
      type: Object
    }
  }
}
</script>